import ClockIconPath from "@ingka/ssr-icon/paths/clock";

export default ClockIconPath;
